module.exports = __webpack_public_path__ + "img/duplicate-icon.6f595943.svg";